import React from 'react';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import Chip from 'components/Chip';
import { ChipWrapper, AddonChip, PlanType } from './styled';
import InfoItem from '../InfoItem';
import { InfoGroup } from '../../styled';

const InsuranceSummary = () => {
  const { startDate, addons, hasEndDate, endDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const { beneficiary } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.basicInfo
  );
  const { destinations } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.destinations
  );

  return (
    <InfoGroup>
      <InfoItem heading="Plan type">
        <PlanType>Essential</PlanType>
      </InfoItem>
      <InfoItem heading="Coverage start date">
        {startDate && format(parseISO(startDate), 'MMMM d, yyyy')}
      </InfoItem>
      {hasEndDate && (
        <InfoItem heading="End date">
          {endDate && format(parseISO(endDate), 'MMMM d, yyyy')}
        </InfoItem>
      )}
      <InfoItem heading="Add-ons">
        {addons.length > 0 ? (
          <ChipWrapper>
            {addons.map((addon) => (
              <AddonChip
                key={addon.name}
                text={addon.name}
                icon={<img src={addon.img} alt={addon.name} />}
              />
            ))}
          </ChipWrapper>
        ) : (
          '-'
        )}
      </InfoItem>
      <InfoItem heading="Destinations">
        {destinations.length > 0 ? (
          <ChipWrapper>
            {destinations.map((country, index) => (
              <Chip key={index} countryCode={country} />
            ))}
          </ChipWrapper>
        ) : (
          '-'
        )}
      </InfoItem>
      <InfoItem heading="Beneficiary">{beneficiary}</InfoItem>
    </InfoGroup>
  );
};

export default InsuranceSummary;
